/// <reference path="../base/api.js" />
/// <reference path="../vendors/intact/jquery-3.4.1.js" />

(function ($) {
    api.forms = {
        inputWithPasswords: function () {
            document.addEventListener(
                "click",
                function (e) {
                    const btn = $(e.target).closest(".btn--show-password");

                    if (btn.length) {
                        btn.toggleClass("active");
                        const inptId = btn.attr("aria-controls");
                        const inpt = inptId ? $("#" + inptId) : null;

                        if (inpt && inpt.length) {
                            if (btn.hasClass("active")) {
                                inpt.attr('type', "text")
                            } else {
                                inpt.attr('type', "password")
                            }
                        }
                    }
                },
                true
            );
        },
        preventPaste: function () {
            document.addEventListener(
                "paste",
                function (e) {
                    const input = $(e.target).closest("input.prevent-paste");
                    if (input.length) {
                        e.preventDefault();
                    }
                },
                true
            );
        }      
    };
})(jQuery);
